import React, { ReactElement, useEffect } from 'react';
import { useDataCollection } from '../../../../hooks';
import CheckCard from '../../../components/Form/CheckCard';
import { InjectedWizardStepProps } from '../../../components/Steps/WizardStep';
import StepHeader from '../../../components/Layout/StepHeader';
import { wallInsulationOptions } from '../../../../data/enumerations';
import { WizardStep } from '../../../../types';
import { Form } from 'formik';

const StepWallInsulation = ({ completeStep, setNextStepId }: InjectedWizardStepProps): ReactElement<'div'> | null => {
    const { handleChange, values } = useDataCollection();

    useEffect(() => {
        if (values.wallInsulation) {
            const nextStepId =
                values.wallInsulation === 'NONE' ? WizardStep.FloorInsulation : WizardStep.WallInsulationThickness;
            setNextStepId && setNextStepId(nextStepId);
            completeStep && completeStep(true);
        }
    }, [values, completeStep]);

    return (
        <Form>
            <StepHeader title="Zateplení stěn" />
            <div className={'wiz-card wiz-card--small'}>
                <div className={'wiz-card__inner'}>
                    {wallInsulationOptions.map(({ value, title, description, img }) => {
                        return (
                            <div key={value} className={'wiz-card-item'}>
                                <CheckCard
                                    name={'wallInsulation'}
                                    onChange={handleChange}
                                    checked={values.wallInsulation === value}
                                    value={value}
                                    img={img}
                                    bigImg={true}
                                    title={title}
                                    description={description}
                                />
                            </div>
                        );
                    })}
                </div>
            </div>
        </Form>
    );
};

export default StepWallInsulation;
